<main-header></main-header>
<main>
    <div class="container">
        <div class="top-part">
            <div class="breadcrumb">
                <import-navigator currentStep="upload"></import-navigator>
                <div class="wrap-text">
                    <b i18n="upload page header|shown on top of the page@@loadData">
                        Load data
                    </b>
                </div>
            </div>
        </div>
        <div class="middle-part load-data">
            <div class="load-data_field">
                <div *ngIf="!fileToUpload" i18n="select xlsx@@upload-file.selectXlsx">
                    <label for="file"><b>Select an Excel file</b></label> from you computer or <label><b (click)="pickAndDownloadFile()">pick from your Google Drive</b></label>
                </div>
                <div class="font-small" *ngIf="fileToUpload">
                    selected data
                </div>
                <div *ngIf="fileToUpload">
                    <b>{{filename}}</b>
                </div>
                <div class="font-small" *ngIf="fileToUpload">
                    <label for="file">
                        re-select
                    </label>
                </div>

                <input type="file" accept=".xlsx, .dwp"
                       id="file" name="file" enctype="multipart/form-data"
                       (change)="handleFileInput($event.target.files)">
            </div>
            <div class="actions">
                <div class="actions-links" *ngIf="false">
                    <span>download <a>example Excel data-set</a></span>
                    <span class="divider">|</span>
                    <span>review <a>data formatting directions</a></span>
                </div>

                <div class="actions-create">
                    <div class="wrap-btn">
                        <button [ngClass]="{'disabled':!fileToUpload && !googleDocUrlIsValid(), 'loading-small':loading, 'btn':true, 'btn-green': true, 'btn-middle':true}"
                                (click)=uploadFile()>
                            Create new project
                        </button>
                    </div>
                    <a *ngIf="false">other options</a>
                </div>
            </div>
        </div>
        <div *ngIf="exampleArticles" class="bottom-part">
            <a *ngFor="let item of exampleArticles" [href]="item.articleUrl" target="_blank" class="block-example">
                <span *ngIf="!item.iconUrl" class="text-dark">{{item.title}}</span>
                <img *ngIf="item.iconUrl" [src]="item.iconUrl">
            </a>
        </div>
    </div>
</main>
